export const corporate = {
    hero: {
        title: "À propos de DONKEY TRAVEL",
        subtitle: "Découvrez notre histoire, notre vision, et l'équipe passionnée qui réinvente l'échange de maisons pour les hôtes les plus exigeants."
    },
    mission: {
        badge: "Notre Mission",
        title: "Démocratiser le voyage premium entre pairs",
        description: "DONKEY TRAVEL a été créé avec une ambition simple : permettre aux meilleurs hôtes de profiter eux aussi des fruits de leur travail. Nous croyons que les propriétaires de logements exceptionnels, notés 4,5 et plus, méritent une plateforme dédiée où ils peuvent échanger leurs biens en toute confiance, sans les frictions financières des locations traditionnelles."
    },
    philosophy: {
        badge: "Philosophie & Valeurs",
        title: "Au cœur de notre club",
        description: "Nous ne sommes pas qu'une plateforme, nous sommes une communauté fondée sur la confiance, le respect mutuel et l'excellence de l'hospitalité.",
        values: {
            fair: {
                title: "Équité",
                desc: "Notre système d'échange est conçu pour être juste et transparent. Vous offrez du temps dans votre logement, vous gagnez du temps pour voyager. C'est simple, sans frais cachés."
            },
            local: {
                title: "Immersion",
                desc: "L'échange de maisons, c'est l'opportunité de vivre comme un local, de découvrir des régions hors des sentiers battus, et de créer des liens authentiques."
            },
            community: {
                title: "Confiance",
                desc: "En réservant notre club aux hôtes notés 4,5+, nous garantissons un niveau d'exigence et de qualité irréprochable au sein de notre réseau."
            }
        }
    },
    team: {
        badge: "L'équipe",
        title: "Derrière DONKEY TRAVEL",
        subtitle: "Une plateforme née de la passion du voyage et de l'hospitalité.",
        members: {
            ceo: {
                name: "Sylvain",
                role: "Fondateur & CEO",
                bio: "Hôte passionné depuis des années, Sylvain a imaginé DONKEY TRAVEL en cherchant lui-même une solution pour voyager gratuitement tout en valorisant son propre gîte. Animé par la volonté de créer le meilleur club d'échange européen, il veille chaque jour à l'excellence de la communauté."
            }
        }
    },
    investors: {
        badge: "Investisseurs & Partenaires",
        title: "Rejoignez l'aventure",
        description: "DONKEY TRAVEL est en pleine croissance et nous sommes toujours ouverts aux opportunités stratégiques pour accélérer notre développement à travers l'Europe.",
        cta: "Nous contacter"
    }
};
